<div *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>


<div *ngIf="!isLoading">
    <div
        style="height: 100%; background-color: white; color: #3d3d3d; padding-top: 10px; padding-left: 70px; padding-right: 70px; padding-bottom: 10px;">

        <div id="view_staffelpreise"></div>

        <div class="row">


            <div class="col-8">

                <button mat-icon-button aria-label="Back to the Shop" (click)="goBack()">
                    <mat-icon class="matIcon-md-grey mr-2" [inline]="true">arrow_back</mat-icon>Zurück zum Shop
                </button>

                <button mat-icon-button aria-label="Warenkorb löschen" matTooltip="Warenkorb löschen" disabled="{{warenkorb.warenkorbPositionen.length == 0}}" (click)="onDeleteWarenkorb(warenkorb)" style="float:right;">
                    <mat-icon class="matIcon-md-grey mr-2" [inline]="true">delete_sweep</mat-icon>
                </button>

                <div *ngFor="let wkPos of warenkorbPositionen; let i = index">

                    <!-- <div class="card artikelcardList card-custom card-stretch gutter-b h-100 d-flex" (click)="onOpenArtikelQuickView(artikel)"> -->
                    <div class="card artikelcardList card-custom card-stretch gutter-b h-100 d-flex">
                        <div class="row card-body d-flex align-items-center">
                            <div class="col-2 d-flex justify-content-center">
                                <img src="data:image/jpeg;base64,{{wkPos.artikelBildKlein}}"
                                    *ngIf="wkPos.artikelBildKlein != null" style="max-width: 100px" />
                                <img src="{{imgDummy}}" *ngIf="wkPos.artikelBildKlein == null"
                                    style="max-height: 25%; max-width: 25%" />

                                <!-- <button mat-icon-button class="btn btn1" aria-label="Card-Basket" *ngIf="artikel.bestand > 0" (click)="onAddToWarenkorb(artikel); $event.stopPropagation()" matTooltip="In den Warenkorb">
                                    <i class="flaticon2-shopping-cart-1 icon-lg"></i>
                                </button> -->

                                <!-- ******************************************** -->
                                <!-- TODO: ADD AS SOON AS DETAILVIEW IS ACTIVATED -->
                                <!-- ******************************************** -->

                                <!-- <button mat-icon-button class="btn btn2" aria-label="Card-Details" (click)="onOpenArtikelDetailView(artikel); $event.stopPropagation()" matTooltip="Details anzeigen">
                                    <i class="flaticon2-search-1 icon-lg"></i>
                                </button> -->

                            </div>

                            <div class="col-7">
                                <div class="title">
                                    <strong>{{wkPos.artikelName}}</strong>
                                </div>
                                <div class="mt-4">
                                    Art. Nr.: <strong>{{wkPos.artikelnummer}}</strong>
                                </div>
                                <div *ngIf="wkPos.artNrKunde!=null">
                                    Kunden Art. Nr. <span class="kundartnr">{{wkPos.artNrKunde}}</span>
                                </div>
                                <div class="mt-2" *ngIf="wkPos.yWert != null && wkPos.yWert != ''">
                                    Farbe: <strong>{{wkPos.yWert}}</strong>
                                </div>
                                <div *ngIf="wkPos.xWert != null && wkPos.xWert != ''">
                                    Grösse: <strong>{{wkPos.xWert}}</strong>
                                </div>
                                <div class="text mt-2 linebreak">
                                    {{wkPos.artikelBeschreibung}}
                                </div>

                                <div class="price mt-2" *ngIf="wkPos.ws_ohneverrechnung != 1" style="display: flex;">
                                    <div class="sum_top">
                                        <div class="net_l">Netto {{wkPos.einzelpreisNetto | currency: 'EUR'}}</div>
                                        <div class="sum_net">(Gesamt {{wkPos.gesamtpreisNetto | currency: 'EUR'}})</div>
                                    </div>
                                    <div class="priceinfo_staffel" *ngIf="wkPos.staffelpreisartikel == true && wkPos.pricesource != 'FP_K'"
                                        title="Staffelpreis ({{wkPos.pricesource}}) - klicken für Übersicht" (click)="onShowStaffel($event, i)"></div>
                                    <div class="priceinfo"
                                        *ngIf="wkPos.pricesource != 'STFP_A' && wkPos.pricesource != 'STFP_K' && wkPos.pricesource != 'STD_A'"
                                        title="({{wkPos.pricesource}})"></div>
                                </div>
                                <div class="view_staffelpreise"
                                    *ngIf="wkPos.staffelpreisartikel == true && wkPos.ws_ohneverrechnung != 1"></div>
                                <div class="sum_top b" *ngIf="wkPos.ws_ohneverrechnung != 1">
                                    <div class="brut_l">Brutto {{wkPos.einzelpreisBrutto | currency: 'EUR'}}</div>
                                    <div class="sum_brut">(Gesamt {{wkPos.gesamtpreisBrutto | currency: 'EUR'}})</div>
                                </div>
                                <div *ngIf="wkPos.rabatt != null && wkPos.rabatt != 0 && wkPos.ws_ohneverrechnung != 1">
                                    (inklusive {{wkPos.rabatt}} % Rabatt)
                                </div>
                                <div class="price mt-2" *ngIf="wkPos.ws_ohneverrechnung == 1" style="display: flex;">
                                    <div class="info_wk"></div><span>Preis auf Anfrage!</span>
                                </div>

                                <div style="display: flex; margin-top: 5px; width:100%;">
                                    <div class="input-form" style="width:90%;">
                                        <mat-form-field appearance="fill" style="width: 100%;">
                                            <mat-label>Notiz</mat-label>
                                            <textarea type="text" [(ngModel)]="wkPos.notiz" matInput id="notiz"
                                                (ngModelChange)="onChangeNotiz($event, i)" style="min-height: 15px;"></textarea>
                                        </mat-form-field>
                                    </div>
                                    <div>
                                        <div *ngIf="isUpdateNotiz[i]">
                                            <button mat-icon-button aria-label="Update data" (click)="onUpdate(wkPos, i)" matTooltip="Änderungen speichern">
                                                <span class="matIcon-md-grey material-icons-outlined">save</span>
                                            </button>
                                        </div>
                                        <div *ngIf="isUpdateNotiz[i]">
                                            <button mat-icon-button aria-label="Cancel Update" (click)="onCancelUpdate(i)" matTooltip="Abbrechen">
                                                <span class="matIcon-md-grey material-icons-outlined">cancel</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- </div> -->
                            <!-- <div class="row">
                            <div class="col mr-4" align="right" *ngIf="wkPos.bestand > 0">
                                <span class="material-icons-outlined matIcon-md" style="color:#34dd34" matTooltip="Artikel auf Lager">
                                    circle
                                </span>
                            </div>
                            <div class="col mr-4" align="right" *ngIf="wkPos.bestand < 1">
                                <span class="material-icons-outlined matIcon-md" style="color:#4ca2b5" matTooltip="Artikel nicht auf Lager">
                                    circle
                                </span>
                            </div>
                        </div>
                        <div class="input-form" *ngIf="wkPos.bestand > 0">
                            <mat-form-field appearance="fill">
                                <mat-label>Menge</mat-label>
                                <input type="number" matInput required min="0" max="{{wkPos.bestand}}" [formControl]="wkPos.menge" (change)="onChangeMenge($event, wkPos.bestand)" id="menge" required>
                                <mat-hint>{{wkPos.bestand}} Artikel auf Lager</mat-hint>
                                <mat-error *ngIf="wkPos.menge.invalid">{{getErrorMessageMenge()}}</mat-error>
                            </mat-form-field>
                        </div> -->




                            <!-- <div class="input-form" *ngIf="bestand > 0">
                            <mat-form-field appearance="fill">
                                <mat-label>Menge</mat-label>
                                <input type="number" matInput required min="0" max="{{bestand}}" [formControl]="menge" (change)="onChangeMenge($event)" id="menge" required>
                                <mat-hint>{{bestand}} Artikel auf Lager</mat-hint>
                                <mat-error *ngIf="menge.invalid">{{getErrorMessageMenge()}}</mat-error>
                            </mat-form-field>
                        </div> -->



                            <!-- FROM artikel-quick-view::START -->

                            <!-- <div class="input-form" *ngIf="wkPos.bestand > 0">
                                <mat-form-field appearance="fill">
                                    <mat-label>Menge</mat-label>
                                    <input type="number" matInput required min="0" max="{{wkPos.bestand}}" [formControl]="menge" (change)="onChangeMenge($event, wkPos.bestand)" id="menge" required>
                                    <mat-hint>{{wkPos.bestand}} Artikel auf Lager</mat-hint>
                                    <mat-error *ngIf="menge.invalid">{{getErrorMessageMenge()}}</mat-error>
                                </mat-form-field>
                            </div> -->

                            <!-- FROM artikel-quick-view::END -->

                            <div class="col-2">
                                <!-- <div class="input-form" *ngIf="wkPos.bestand > 0"> vorher nur wenn Bestand in Pos > 0 -->
                                <div class="input-form">
                                    <mat-form-field appearance="fill" style="width:100%">
                                        <mat-label>Menge</mat-label>
                                        <input type="number" [(ngModel)]="wkPos.menge" matInput required min="1"
                                            id="menge" (ngModelChange)="onChangeMenge($event, i)" required>

                                        <mat-hint *ngIf="wkPos.bestand > 0">
                                            <div style="float: left; margin-right: 5px;" *ngIf="wkPos.bestand > 0">
                                                <span class="material-icons matIcon-md" style="color:#34dd34"
                                                    matTooltip="Artikel auf Lager">
                                                    fiber_manual_record
                                                </span>
                                            </div>{{wkPos.bestand}} Artikel auf Lager
                                        </mat-hint>
                                        <mat-hint *ngIf="wkPos.bestand < 1">
                                            <div style="float: left; margin-right: 5px;" *ngIf="wkPos.bestand < 1">
                                                <span class="material-icons matIcon-md" style="color:#ff0000"
                                                    matTooltip="Artikel nicht auf Lager">
                                                    fiber_manual_record
                                                </span>
                                            </div>
                                            0 Artikel auf Lager
                                        </mat-hint>
                                        <!-- <mat-error *ngIf="wkPos.menge.invalid">{{getErrorMessageMenge()}}</mat-error> -->
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-1">
                                <div *ngIf="isUpdate[i]">
                                    <button mat-icon-button aria-label="Update data" (click)="onUpdate(wkPos, i)"
                                        matTooltip="Änderungen speichern">
                                        <span class="matIcon-md-grey material-icons-outlined">save</span>
                                    </button>
                                </div>

                                <div *ngIf="isUpdate[i]">
                                    <button mat-icon-button aria-label="Cancel Update" (click)="onCancelUpdate(i)"
                                        matTooltip="Abbrechen">
                                        <span class="matIcon-md-grey material-icons-outlined">cancel</span>
                                    </button>
                                </div>

                                <div>
                                    <button mat-icon-button aria-label="Delete item" (click)="onDelete(wkPos)"
                                        matTooltip="Artikel entfernen">
                                        <mat-icon class="matIcon-md-grey" [inline]="true">delete_outline</mat-icon>
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>



            </div>
            <div class="col-4">
                <div class="card artikelcardList card-custom gutter-b d-flex">
                    <div class="card-body d-flex justify-content-center" style="font-size:1.15rem;">
                        <div class="container" align="center">
                            <div>
                                Summe
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col" align="left">
                                    <div>Anzahl Artikel</div>
                                </div>
                                <div class="col" align="right">
                                    {{nWkPos}}
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col" align="left">
                                    <div>Gesamt Netto</div>
                                </div>
                                <div class="col" align="right">
                                    <div style="font-weight:600">
                                        {{(warenkorb.ws_ohneverrechnung == 1 ? '0' : gesamtNetto) | currency:'EUR'}}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col" align="left">
                                    <div>Gesamt Steuern</div>
                                </div>
                                <div class="col" align="right">
                                    <div style="font-weight:600">
                                        {{(warenkorb.ws_ohneverrechnung == 1 ? '0' : gesamtSteuerBetrag) | currency:'EUR'}}                                        
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col" align="left">
                                    <div>Gesamt Brutto</div>
                                </div>
                                <div class="col" align="right">
                                    <div style="font-weight:600">
                                        {{(warenkorb.ws_ohneverrechnung == 1 ? '0' : gesamtBrutto) | currency:'EUR'}}
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="row" *ngIf="warenkorb.checkoutinfo != null && warenkorb.checkoutinfo != ''">
                                <div class="div_checkoutinfo"></div>
                                <div style="text-align: left; padding: 0.5rem;">
                                    {{warenkorb.checkoutinfo}}
                                </div>
                            </div>
                            <hr>
                            
                            <div class="row">
                                <div style="display: flex; width: 100%;">
                                    <div class="input-form;" style="width: 100%">
                                        <mat-form-field appearance="fill" style="width: 100%">
                                            <mat-label>Notiz</mat-label>
                                            <textarea type="text" [(ngModel)]="warenkorb.notiz" matInput id="notizWK" [disabled]="warenkorb.warenkorbPositionen.length == 0"
                                                (ngModelChange)="onChangeReceiptNotiz($event)" style="min-height: 15px;"></textarea>
                                        </mat-form-field>
                                    </div>
                                    <div>
                                        <div *ngIf="isUpdateReceiptNotiz">
                                            <button mat-icon-button aria-label="Update data" (click)="onUpdateWK(warenkorb)" matTooltip="Notiz speichern">
                                                <span class="matIcon-md-grey material-icons-outlined">save</span>
                                            </button>
                                        </div>
                                        <div *ngIf="isUpdateReceiptNotiz">
                                            <button mat-icon-button aria-label="Cancel Update" (click)="onCancelUpdateWK()" matTooltip="Abbrechen">
                                                <span class="matIcon-md-grey material-icons-outlined">cancel</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div style="display: flex; width: 100%">
                                    <div class="input-form" style="width: 100%">
                                        <mat-form-field appearance="fill" style="width: 100%;">
                                            <mat-label>Kd-Auftragsnr.:</mat-label>
                                            <input type="text" [(ngModel)]="warenkorb.kdAuftragNr" matInput id="kdauftragnr" (ngModelChange)="onChangeKDAuftragNr($event)" style="min-height: 15px;" [disabled]="warenkorb.warenkorbPositionen.length == 0" maxlength="50">
                                        </mat-form-field>
                                    </div>
                                    <div>
                                        <div *ngIf="isUpdateKDAuftragNr">
                                            <button mat-icon-button aria-label="Update data" (click)="onUpdateWK(warenkorb)" matTooltip="Kundenauftrags-Nr. speichern">
                                                <span class="matIcon-md-grey material-icons-outlined">save</span>
                                            </button>
                                        </div>
                                        <div *ngIf="isUpdateKDAuftragNr">
                                            <button mat-icon-button aria-label="Cancel Update" (click)="onCancelUpdateKDAuftragNr()" matTooltip="Abbrechen">
                                                <span class="matIcon-md-grey material-icons-outlined">cancel</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="row">
                                <div class="col" align="left">
                                    <div>Gesamt Rabatt</div>
                                </div>
                                <div class="col" align="right">
                                    <div style="font-weight:600">
                                        {{gesamtRabattBetrag * (-1) | currency:'EUR'}}
                                    </div>
                                </div>
                            </div> -->

                            <div class="break"></div>
                            <div class="row">
                                <div class="col-6">
                                    <button mat-raised-button color="accent" (click)="checkout(1)"
                                        disabled="{{warenkorb.warenkorbPositionen.length == 0}}">Angebot
                                        anfragen</button>
                                </div>
                                <div class="col-6">
                                    <button mat-raised-button color="accent" (click)="checkout(2)"
                                        disabled="{{warenkorb.warenkorbPositionen.length == 0 || warenkorb.ws_ohneverrechnung == 1}}">Bestellung
                                        aufgeben</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>



        </div>






    </div>
</div>